import React, { useState } from "react";
import "../../index.css";
import Customer from "../../assets/termsandconditions/Customer.svg";
import Retailer from "../../assets/termsandconditions/Retailer.svg";
import Star from "../../assets/termsandconditions/star.svg";
import DropDown from "../../assets/termsandconditions/dropdown.svg";
import DropUp from "../../assets/termsandconditions/dropup.svg";

const PrivacyPolicyGenie = () => {
    const [customerCard, setCustomerCard] = useState(false);
    const [vendorCard, setVendorCard] = useState(false);

    return (
        <div className="max-sm:px-[30px] max-lg:px-[50px] lg:mx-[120px] pt-[100px] md:pt-[120px] overflow-x-hidden">
            <div>
                <h1 className="text-[28px]  text-[#2E2C43] poppins-black  max-sm:text-[26px]">
                    *Privacy & Policy
                </h1>
            </div>
            <div className="w-full flex flex-col gap-[40px] mt-[30px] mb-[30px] md:mt-[30px]  ">

                <div className="mb-[30px] flex ">
                    <div className="w-[100%]  sm:p-[20px] flex flex-col gap-4 mx-auto">

                        <div className="relative pb-[40px]">
                            <p className="text-[20px] poppins-extrabold text-[#2E2C43]">
                                CulturTap Genie
                            </p>
                            <ul className="flex flex-col mt-[20px]">
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        We collect personal information, including your Name, Mobile Number, and Email Address, to provide you with a personalized experience and better service
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Use of Personal Data: We collect personal data to create and manage your account, process your orders and invoices, identify you on our platform, and contact you to respond to your queries.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Data Privacy: We respect your privacy and do not share any of your data with third parties. Vendors will only receive your information once you’ve finalized your deal.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]  poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                App Permissions:{" "}
                                            </span>
                                            Notifications, Camera, Gallery, Storage, Location.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px] pl-[25px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px] poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Notifications:{" "}
                                            </span>
                                            Required to send app notifications for updates and offers.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px] pl-[25px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Camera:{" "}
                                            </span>
                                            Needed to capture product and profile images, update your profile, and send product attachments during bargaining.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px] pl-[25px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Gallery:{" "}
                                            </span>
                                            Required to upload and save product and profile images in your gallery.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px] pl-[25px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Storage:{" "}
                                            </span>
                                            Needed to store images and documents within the app.
                                           </p>
                                    </div>
                                </li>
                                <li className="text-[14px] pl-[25px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">

                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Location:{" "}
                                            </span>
                                            Helps us determine your current location to connect you with valid vendors nearby for shopping.                                
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Data Sharing : 
                                        We have separate apps for targeting customers (demand) and vendors (supply). We securely share data between these apps only with your consent. Rest assured, we do not sell any of your data to third parties. All necessary permissions are requested during the launch of the application to ensure a seamless experience.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            Account Deletion & Support:
                                            If you wish to delete your account, simply visit the "Need any help?" section in the app menu. You can raise an account deletion request, and we will handle it promptly. We’re also here to assist with any other concerns or use cases you may have!
                                        </p>
                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PrivacyPolicyGenie;
